import { Label } from "./label";
import { FieldProps } from "./wrapper";

export const InfoField = ({ field }: FieldProps) => (
  <Label {...field} fontWeight="normal" fontSize="paragraph" />
);
